"use client";

import dynamic from "next/dynamic";

export const TTSAPIWrapper = dynamic(() => import("./TTSAPI").then(mod => mod.TTSAPI));
